module.exports = __webpack_public_path__ + "static/media/logo-wd.5e73890b.svg";